export function buildFileFormData ({
     nameEn,
     nameAr,
     file,
     courseId,
     thumbnail
}) {
     const formData = new FormData();
     formData.append('name_en', nameEn);
     formData.append('name_ar', nameAr);
     if (file instanceof File)
          formData.append('file', file);
     if (courseId)
          formData.append('course_id', courseId);
     if (thumbnail instanceof File)
          formData.append('thumbnail', thumbnail);

     return formData;
}